import React from 'react'
import { Card } from 'react-bootstrap'
import { formatPaymentDate } from '../../utils/utils'
import { VoucherType } from '../../types'

const ApprovalStages = ({ voucher }: { voucher: VoucherType }) => {
  const approvals = voucher?.voucher_approvals || []

  // Sort approvals by order_number
  const sortedApprovals = [...approvals].sort(
    (a, b) => a.order_number - b.order_number
  )

  return (
    <div className="my-2">
      <div
        className="d-flex flex-wrap align-items-center justify-content-center gap-3"
        style={{ width: '100%' }}
      >
        {sortedApprovals.map((approval, index) => {
          const { approver, approval_stage, status, approved_at, comment } =
            approval
          const roleName = `${approver?.user_role?.name || 'Unknown'} (${
            approver?.majlis || '-'
          })`
          const email = approver?.email || 'N/A'
          const labelPrefix = approval_stage?.is_payment_stage
            ? 'Payment'
            : 'Approval'

          // Status-based coloring
          const isApproved = status === 'APPROVED' || status === 'PAID'
          const bgColor = isApproved
            ? 'rgba(25, 135, 84, 0.1)'
            : 'rgba(108, 117, 125, 0.05)'
          const borderColor = isApproved ? '#198754' : '#dee2e6'
          const textColor = isApproved ? '#155724' : '#212529'

          return (
            <React.Fragment key={`approval-fragment-${approval.id || index}`}>
              <Card
                className="shadow-sm rounded-4"
                style={{
                  minWidth: '220px',
                  maxWidth: '280px',
                  backgroundColor: bgColor,
                  border: `1px solid ${borderColor}`,
                  color: textColor,
                  flex: '1 1 0',
                }}
              >
                <Card.Body className="p-1">
                  <Card.Text as="div" style={{ lineHeight: 1.6 }}>
                    <div>
                      <strong>{labelPrefix}:</strong> {roleName}
                    </div>
                    <div>{email}</div>
                    {approved_at && (
                      <div>
                        <strong>Date:</strong>
                        {' ' + formatPaymentDate(approved_at)}
                      </div>
                    )}
                    {comment && (
                      <div>
                        <strong>Comment:</strong> {comment}
                      </div>
                    )}
                  </Card.Text>
                </Card.Body>
              </Card>

              {/* Add arrow between cards (except last one) */}
              {index < sortedApprovals.length - 1 && (
                <div
                  key={`arrow-${approval.id || index}`}
                  style={{
                    fontSize: '1.5rem',
                    color: '#6c757d',
                    margin: '0 10px',
                  }}
                >
                  →
                </div>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default ApprovalStages
